import { useState, useEffect } from 'react';
import SalesForceImg from 'assets/salesforce.png';
import HubspotImg from 'assets/hubspot.png';
import PipedriveImg from 'assets/pipedrive.png';
import ActiveCampaingImg from 'assets/activecampaign.png';
import MondayImg from 'assets/monday.png';
import QhareImg from 'assets/quare.jpg';
import CostructorImg from 'assets/costructor-logo.jpeg';
import GsheetImg from 'assets/gsheet.png';
import CheelyImg from 'assets/chelly.svg';
import kelvinImg from 'assets/kelvin.png';
import { useDisclosure } from '@chakra-ui/hooks';
import ApiKeyModal from './components/ApiKeyModal';
import WebhookModal from './components/WebhookModal';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MdWebhook, MdOutlineExtension } from 'react-icons/md';

const statusConfig: Record<string, { label: string; className: string }> = {
    online:      { label: 'Connecté',      className: 'bg-leadrs-green-soft text-leadrs-green-focus' },
    offline:     { label: 'Déconnecté',    className: 'bg-leadrs-red-soft text-leadrs-red-focus' },
    'not-setup': { label: 'Non configuré', className: 'bg-leadrs-yellow-soft text-leadrs-yellow-focus' },
    'coming-soon':{ label: 'Bientôt',      className: 'bg-leadrs-stroke text-leadrs-text-soft' },
};

const Integrate = () => {
    const [loading, setLoading] = useState(false);
    const [selectedService, setSelectedService] = useState<{ name: string; service: string } | null>(null);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isWebhookOpen, onOpen: onWebhookOpen, onClose: onWebhookClose } = useDisclosure();
    const [webhookLoading, setWebhookLoading] = useState(false);
    const [services, setServices] = useState([
        {
            name: 'Webhook',
            service: 'webhook',
            description: 'Recevez vos leads en temps réel sur votre propre serveur via une requête HTTP POST en JSON.',
            logo: (
                <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-leadrs-blue-soft">
                    <MdWebhook size={28} className="text-leadrs-blue-focus" />
                </div>
            ),
            status: 'not-setup',
            onLogin: () => { onWebhookOpen(); },
        },
        {
            name: 'Qhare',
            service: 'Qhare',
            description: 'Plateforme complète dédiée aux professionnels du bâtiment, spécialisés dans les énergies renouvelables et la rénovation énergétique.',
            logo: QhareImg,
            status: 'not-setup',
            onLogin: () => { setSelectedService({ name: 'Qhare', service: 'Qhare' }); onOpen(); },
        },
        {
            name: 'Costructor',
            service: 'costructor',
            description: 'Recevez vos leads directement dans votre compte Costructor, le CRM dédié aux professionnels de la construction et de la rénovation.',
            logo: CostructorImg,
            status: 'not-setup',
            onLogin: () => { setSelectedService({ name: 'Costructor', service: 'costructor' }); onOpen(); },
        },
        {
            name: 'SalesForce',
            service: 'meta',
            description: 'Recevez vos leads directement dans votre compte SalesForce.',
            logo: SalesForceImg,
            status: 'coming-soon',
            onLogin: () => {},
        },
        {
            name: 'Kelvin',
            service: 'kelvin',
            description: "Avec l'IA kelvin°, les entreprises RGE chiffrent les travaux de rénovation énergétique en quelques instants et sans erreur.",
            logo: kelvinImg,
            status: 'coming-soon',
            onLogin: () => {},
        },
        {
            name: 'Chelly',
            service: 'chelly',
            description: 'Recevez vos leads directement dans votre compte Chelly.',
            logo: CheelyImg,
            status: 'coming-soon',
            onLogin: () => {},
        },
        {
            name: 'Hubspot',
            service: 'gmb',
            description: 'Recevez vos leads directement dans votre compte Hubspot.',
            logo: HubspotImg,
            status: 'coming-soon',
            onLogin: () => {},
        },
        {
            name: 'PipeDrive',
            service: 'fork',
            description: 'Recevez vos leads directement dans votre compte PipeDrive.',
            logo: PipedriveImg,
            status: 'coming-soon',
            onLogin: () => {},
        },
        {
            name: 'Monday',
            service: 'fork',
            description: 'Recevez vos leads directement dans votre compte Monday.',
            logo: MondayImg,
            status: 'coming-soon',
            onLogin: () => {},
        },
        {
            name: 'Active Campaign',
            service: 'fork',
            description: 'Recevez vos leads directement dans votre compte Active Campaign.',
            logo: ActiveCampaingImg,
            status: 'coming-soon',
            onLogin: () => {},
        },
        {
            name: 'Google Sheet',
            service: 'gsheet',
            description: 'Recevez vos leads directement depuis votre compte Google Sheet.',
            logo: GsheetImg,
            status: 'coming-soon',
            onLogin: () => {},
        },
    ]);

    useEffect(() => {
        checkIntegrations();
    }, []);

    const checkIntegrations = async () => {
        try {
            const token = localStorage.getItem('token');
            const headers = { Authorization: `Bearer ${token}` };
            const [qhareRes, webhookRes, costructorRes] = await Promise.all([
                axios.get(`${CONFIG.apiUrl}/integration/check/Qhare`, { headers }),
                axios.get(`${CONFIG.apiUrl}/integration/check/webhook`, { headers }),
                axios.get(`${CONFIG.apiUrl}/integration/check/costructor`, { headers }),
            ]);
            setServices((prev) =>
                prev.map((service) => {
                    if (service.service === 'Qhare' && qhareRes.data.success && qhareRes.data.exists)
                        return { ...service, status: qhareRes.data.isActive ? 'online' : 'offline' };
                    if (service.service === 'webhook' && webhookRes.data.success && webhookRes.data.exists)
                        return { ...service, status: webhookRes.data.isActive ? 'online' : 'offline' };
                    if (service.service === 'costructor' && costructorRes.data.success && costructorRes.data.exists)
                        return { ...service, status: costructorRes.data.isActive ? 'online' : 'offline' };
                    return service;
                })
            );
        } catch (error) {
            console.error('Error checking integrations:', error);
        }
    };

    const handleSaveApiKey = async (apiKey: string) => {
        if (!selectedService) return;
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                `${CONFIG.apiUrl}/integration/api-key`,
                { service: selectedService.service, apiKey },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (response.data.success) {
                toast.success('Clé API enregistrée avec succès!');
                onClose();
                setServices((prev) =>
                    prev.map((s) => s.service === selectedService.service ? { ...s, status: 'online' } : s)
                );
            }
        } catch (error: any) {
            toast.error(error.response?.data?.error || "Erreur lors de l'enregistrement de la clé API");
        } finally {
            setLoading(false);
        }
    };

    const handleDisconnect = async (serviceName: string) => {
        if (!window.confirm(`Êtes-vous sûr de vouloir déconnecter ${serviceName}?`)) return;
        try {
            const token = localStorage.getItem('token');
            const response = await axios.delete(
                `${CONFIG.apiUrl}/integration/${serviceName}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (response.data.success) {
                toast.success('Intégration supprimée avec succès!');
                setServices((prev) =>
                    prev.map((s) => s.service === serviceName ? { ...s, status: 'not-setup' } : s)
                );
            }
        } catch (error: any) {
            toast.error(error.response?.data?.error || "Erreur lors de la déconnexion de l'intégration");
        }
    };

    const handleSaveWebhookUrl = async (url: string) => {
        setWebhookLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                `${CONFIG.apiUrl}/integration/api-key`,
                { service: 'webhook', apiKey: url },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (response.data.success) {
                toast.success('Webhook configuré avec succès!');
                onWebhookClose();
                setServices((prev) =>
                    prev.map((s) => s.service === 'webhook' ? { ...s, status: 'online' } : s)
                );
            }
        } catch (error: any) {
            toast.error(error.response?.data?.error || 'Erreur lors de la configuration du webhook');
        } finally {
            setWebhookLoading(false);
        }
    };

    const handleTestWebhook = async (url: string) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                `${CONFIG.apiUrl}/integration/test-webhook`,
                { url },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return {
                success: !!response.data.success,
                message: response.data.success
                    ? response.data.message || 'Le webhook a bien reçu le payload de test.'
                    : response.data.error || "Le test du webhook a échoué.",
            };
        } catch (error: any) {
            return {
                success: false,
                message: error.response?.data?.error || 'Erreur lors du test du webhook.',
            };
        }
    };

    const PluginCard = (props: {
        logo: any;
        name: string;
        service: string;
        description: string;
        status?: string;
        onLogin?: () => void;
        onDisconnect?: (service: string) => void;
    }) => {
        const { logo, name, description, service, status, onLogin, onDisconnect } = props;
        const badge = statusConfig[status] ?? statusConfig['not-setup'];

        return (
            <div className="relative flex flex-col rounded-xl border border-leadrs-stroke bg-white p-5 shadow-sm">
                <div className="absolute right-3 top-3">
                    <span className={`rounded-full px-2 py-0.5 font-geist text-[11px] font-medium ${badge.className}`}>
                        {badge.label}
                    </span>
                </div>

                <div className="flex-1">
                    {typeof logo === 'string' ? (
                        <img
                            src={logo}
                            alt={`${name}-logo`}
                            className="h-14 w-14 rounded-xl border border-leadrs-stroke object-contain"
                        />
                    ) : (
                        logo
                    )}
                    <h4 className="mt-4 font-crimson text-xl font-semibold text-leadrs-text">{name}</h4>
                    <p className="mt-1.5 font-geist text-xs leading-relaxed text-leadrs-text-soft">{description}</p>
                    {service === 'Qhare' && (
                        <a
                            href="https://crm-Qhare.fr"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-2 inline-block font-geist text-xs text-leadrs-brand hover:opacity-70 transition-opacity"
                        >
                            Accéder à Qhare CRM →
                        </a>
                    )}
                    {service === 'costructor' && (
                        <a
                            href="https://costructor.co/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-2 inline-block font-geist text-xs text-leadrs-brand hover:opacity-70 transition-opacity"
                        >
                            Accéder à Costructor →
                        </a>
                    )}
                </div>

                <div className="mt-5">
                    {status === 'coming-soon' && (
                        <button
                            disabled
                            className="flex h-10 w-full cursor-not-allowed items-center justify-center rounded-xl bg-leadrs-stroke font-geist text-sm font-medium text-leadrs-text-soft"
                        >
                            Bientôt disponible
                        </button>
                    )}
                    {status === 'not-setup' && (
                        <button
                            className="flex h-10 w-full items-center justify-center rounded-xl bg-leadrs-brand font-geist text-sm font-medium text-white hover:opacity-80 transition-opacity"
                            onClick={onLogin}
                        >
                            Associer un compte
                        </button>
                    )}
                    {status === 'online' && (
                        <button
                            className="flex h-10 w-full items-center justify-center rounded-xl border border-leadrs-red-focus font-geist text-sm font-medium text-leadrs-red-focus hover:bg-leadrs-red-soft transition-colors"
                            onClick={() => onDisconnect?.(service)}
                        >
                            Déconnecter
                        </button>
                    )}
                    {status === 'offline' && (
                        <button
                            className="flex h-10 w-full items-center justify-center rounded-xl bg-leadrs-brand font-geist text-sm font-medium text-white hover:opacity-80 transition-opacity"
                            onClick={onLogin}
                        >
                            Me reconnecter
                        </button>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div>
            <ToastContainer />
            <ApiKeyModal
                isOpen={isOpen}
                onClose={onClose}
                serviceName={selectedService?.name || ''}
                onSave={handleSaveApiKey}
                loading={loading}
            />
            <WebhookModal
                isOpen={isWebhookOpen}
                onClose={onWebhookClose}
                onSave={handleSaveWebhookUrl}
                onTest={handleTestWebhook}
                loading={webhookLoading}
            />

            {/* Header */}
            <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
                <div className="flex items-start gap-4">
                    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-leadrs-blue-soft">
                        <MdOutlineExtension className="h-5 w-5 text-leadrs-blue-focus" />
                    </div>
                    <div>
                        <h2 className="font-crimson text-2xl font-semibold leading-tight text-leadrs-text">
                            Intégrations
                        </h2>
                        <p className="mt-1 font-geist text-sm text-leadrs-text-soft">
                            Connectez votre CRM à Leadrs pour recevoir automatiquement vos leads et simplifier le suivi de vos prospects.
                        </p>
                    </div>
                </div>
            </div>

            {/* Grid */}
            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-4">
                {services.map((service, index) => (
                    <PluginCard
                        key={service.service + index}
                        name={service.name}
                        service={service.service}
                        description={service.description}
                        logo={service.logo}
                        status={service.status}
                        onLogin={service.onLogin}
                        onDisconnect={handleDisconnect}
                    />
                ))}
            </div>
        </div>
    );
};

export default Integrate;
